import { parse } from 'query-string';
import { EXPORT_METRICS_TOGGLES, jobNames } from './../helpers';
import {
  LOCATION_CHANGE,
  SELECT_PERFORMANCE_JOB,
  RESET_PERFORMANCE_PAGE
} from './../actions';

const initialState = {
  exportPerformanceInfo: {
    toggles: 15,
    buildFilter: '',
    snPartI: '',
    snPartII: '',
    snPartIII: '',
    givenJob: '',
    dispatcherId: 0,
    jobName: jobNames.EXPORT
  },
  selectedJobs: []
};

const exportPerformancePage = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_PERFORMANCE_JOB:
      if (action.value === undefined) return { ...state };

      const actionAsSelectedJob = {
        value: `${action.value}`,
        index: action.index,
        jobId: action.jobId
      };

      const initSelected = state.selectedJobs.length === 1 ?
        state.selectedJobs[0] && state.selectedJobs[0].value !== action.value ?
          state.selectedJobs :
          [] :
        [];

      return {
        ...state,
        selectedJobs: [...initSelected, actionAsSelectedJob]
      };
    case RESET_PERFORMANCE_PAGE:
      return initialState;
    case LOCATION_CHANGE:
      if (!action.payload ||
        !action.payload.search ||
        action.payload.pathname !== '/export-performance') {
        return state;
      }

      // These are for the main selector:
      // t: build type bit representation
      // f: build filter
      // e: selected export type
      // g: selected configure
      // i: selected casename
      // j: given job number, used to highlight a job coming from another page
      // d: id for selected dispatcher
      // The names need to be short because they're part of the URL query.
      const { f, e, g, i, t, j, d } = parse(action.payload.search);

      const parseExportPerformanceInfo = (
        toggles,
        buildFilter,
        exportType,
        configure,
        caseName,
        givenJob,
        dispatcher,
        metricInfo,
      ) => {
        const parsedToggles = parseInt(toggles);
        const parsedGivenJob = parseInt(j);
        const parsedDispatcher = parseInt(dispatcher);

        return {
          toggles: (parsedToggles < 0) || (parsedToggles > 15) || isNaN(parsedToggles) ?
            metricInfo.toggles :
            parsedToggles,
          buildFilter: buildFilter ? buildFilter : '',
          snPartI: exportType ? exportType : '',
          snPartII: configure ? configure : '',
          snPartIII: caseName ? caseName : '',
          givenJob: (parsedGivenJob < 0) || isNaN(parsedGivenJob) ?
            metricInfo.givenJob :
            parsedGivenJob,
          dispatcherId: (parsedDispatcher < 0) || isNaN(parsedDispatcher) ?
            0 :
            parsedDispatcher,
          jobName: metricInfo.jobName
        };
      };

      const parsedInfo =
        parseExportPerformanceInfo(t, f, e, g, i, j, d, state.exportPerformanceInfo);
      return {
        ...state,
        exportPerformanceInfo: parsedInfo,
        selectedJobs: parsedInfo.givenJob ?
          [{ value: `${parsedInfo.givenJob}` }] :
          []
      };

    default:
      return state;
  }
};

export default exportPerformancePage;

const getExportPerformancePage = state => state.exportPerformancePage;
export const getExportPerformanceInfo = state =>
  getExportPerformancePage(state).exportPerformanceInfo ||
   initialState.exportPerformanceInfo;
export const getExportPerformanceOutliersShown = state =>
  getExportPerformancePage(state).toggles & EXPORT_METRICS_TOGGLES.OUTLIER;
export const getExportPerformanceSelectedJobs = state =>
  getExportPerformancePage(state).selectedJobs;


// WEBPACK FOOTER //
// src/reducers/exportPerformancePage.js